module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'navigation') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导航项"
    }
  }, [_vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item"
    }, [_c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })]), _vm._v(" "), (item.imgUrl) ? _c('img', {
      staticClass: "banner-uploader square",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader square",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }, [_c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    }), _c('br'), _vm._v("\n              上传图片\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "uploader-setting"
    }, [_c('el-input', {
      attrs: {
        "placeholder": "导航名称"
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goods-select",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }, [(item.id) ? _c('div', {
      staticClass: "link-content"
    }, [(item.linkPage === 'goods') ? [_vm._v("商品：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'category') ? [_vm._v("分类：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'article') ? [_vm._v("文章：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'planting') ? [_vm._v("软文：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'link') ? [_vm._v("页面：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'marketing') ? [_vm._v("营销：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'custom_link') ? [_vm._v("自定义链接：")] : _vm._e(), _vm._v(" "), (item.linkPage === 'store_list') ? [_vm._v("店铺类型：")] : _vm._e(), _vm._v("\n                " + _vm._s(item.title) + "\n              ")], 2) : _c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-link",
      on: {
        "click": function($event) {
          return _vm.handleGoodsChange(index)
        }
      }
    }), _vm._v("设置路径")])])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-plus-circle banner-button-uploader",
    attrs: {
      "disabled": _vm.data.length >= 20,
      "type": "default"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v(" 添加项目")])], 2)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fb61feda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb61feda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/navigation.vue
// module id = 2996
// module chunks = 0